import LoginService from './loginService';

export default LoginService;
